import {
  Box, Button, Typography,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NoPermissions } from '../../../components/NoPermissions';
import { PERMISSIONS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';
import { useGetMatchFlows } from '../../../hooks/query/useMatchFlow';
import { useTablePageParams } from '../../../hooks/useTablePageParams';
import { PARAMS_KEYS } from '../paramKeys';
import STRING_KEYS from '../../../language/keys';
import { Refresh } from '../../../icons/refresh';
import { EngineRunStatus } from './EngineRunStatus';
import { MatchEngineStats } from './MatchEngineStats';
import { style } from './style';
import { MatchFlowTable } from './MatchFlowTable';

type PositionDetailsRunsProps = {
  positionId: string,
  accountId: string,
  viewMode: ViewMode,
}

const QUERY_PARAMS = {
  TAB: 'tab',
  PAGE: 'page',
};

export const PositionDetailsRuns = ({
  positionId,
  accountId,
  viewMode,
}:PositionDetailsRunsProps):JSX.Element => {
  const { hasPermissions } = useAuth();
  const { t: translate } = useTranslation();

  const [searchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get(PARAMS_KEYS.PAGE) || '1');

  const {
    onPageChange,
  } = useTablePageParams([
    QUERY_PARAMS.TAB,
    QUERY_PARAMS.PAGE,
  ]);

  const {
    data,
    totalCount,
    page,
    limit,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetMatchFlows(positionId, accountId, Number(currentPage));

  const errorMessage = !isError && error?.response?.data.message;

  if (!hasPermissions([PERMISSIONS.MATCH_FLOW_VIEW])) {
    return <NoPermissions />;
  }

  return (
    <Box
      sx={ style.boxContainer.sx }
    >
      <Box>
        <MatchEngineStats
          viewMode={ viewMode }
          accountId={ accountId }
          positionId={ positionId }
        />

        <EngineRunStatus
          positionId={ positionId }
          accountId={ accountId }
        />

        <Box
          sx={ style.innerBoxContainer.sx }
        >
          <Box
            sx={ style.boxTitle.sx }
          >
            <Typography
              variant={ style.typography.variant }
              color={ style.typography.sx }
            >
              { translate(STRING_KEYS.MATCH_FLOWS) }
            </Typography>
            <Box sx={ style.IconWrapper.sx }>
              <Button
                variant="text"
                onClick={ refetch }
                startIcon={ (
                  <Refresh />
                ) }
              />
            </Box>
          </Box>
          <MatchFlowTable
            data={ data }
            totalCount={ totalCount }
            currentPage={ page }
            limit={ limit }
            isLoading={ isLoading }
            isError={ isError }
            errorMessage={ errorMessage }
            handlePageChange={ (pageNumber) => { onPageChange(pageNumber + 1); } }
          />
        </Box>
      </Box>
    </Box>
  );
};
